var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFirstAidKit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.6 2.09961C16.0968 2.09961 16.5 2.50281 16.5 2.99961V5.69961H20.1C20.5968 5.69961 21 6.10281 21 6.59961V19.1996C21 19.6964 20.5968 20.0996 20.1 20.0996H3.9C3.4032 20.0996 3 19.6964 3 19.1996V6.59961C3 6.10281 3.4032 5.69961 3.9 5.69961H7.5V2.99961C7.5 2.50281 7.9032 2.09961 8.4 2.09961H15.6ZM19.2 7.49961H4.8V18.2996H19.2V7.49961ZM12.9 9.29961V11.9996H15.6V13.7996H12.8991L12.9 16.4996H11.1L11.0991 13.7996H8.4V11.9996H11.1V9.29961H12.9ZM14.7 3.89961H9.3V5.69961H14.7V3.89961Z",
    fill: "#2D9F75"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFirstAidKit);
export default __webpack_public_path__ + "static/media/first-aid-kit.93ad6b97e7cb45b63a55c60a739a93c3.svg";
export { ForwardRef as ReactComponent };